import { Renderer } from './Renderer'
import Simplex from 'simplex-noise'

import {
  PerspectiveCamera,
  Scene,
  Vector3,
  Euler,
} from 'three'

export class WebGL {
  constructor () {
    this.resize = this.resize.bind(this)
    this.tick = this.tick.bind(this)

    // Rendering
    this.time = { date: 0, elapsed: 0, delta: 0 }

    this.scene = new Scene()

    this.camera = new PerspectiveCamera(45, 1, 1, 1000)
    this.camera.far = 500
    this.camera.lookAt( new Vector3(0, 0, 0) )

    // this.cameraNoiseAmplitude = 0
    // this.cameraSimplex = new Simplex()
    // this.cameraPosition = new Vector3()
    // this.cameraRotation = new Euler()
    // this.cameraPositionNoise = new Vector3()
    // this.cameraRotationNoise = new Vector3()
    // this.cameraPositionNoiseAmplitude = new Vector3(0.6, 0.6, 0.6)
    // this.cameraRotationNoiseAmplitude = new Vector3(0, 0.03, 0)

    this.renderer = new Renderer(this.scene, this.camera)

    this.start()
  }

  tick () {
    // if (this.cameraNoiseAmplitude) {
    //   const time = Date.now() / 10000

    //   this.cameraPositionNoise
    //     .set(
    //       this.cameraSimplex.noise3D(0, 0, time),
    //       this.cameraSimplex.noise3D(25, time, 0),
    //       this.cameraSimplex.noise3D(time, 50, 0)
    //     )
    //     .multiply(this.cameraPositionNoiseAmplitude)
    //     .multiplyScalar(this.cameraNoiseAmplitude)

    //   this.cameraRotationNoise
    //     .set(
    //       this.cameraSimplex.noise3D(0, time, 100),
    //       this.cameraSimplex.noise3D(0, 125, time),
    //       this.cameraSimplex.noise3D(50, time, 0)
    //     )
    //     .multiply(this.cameraRotationNoiseAmplitude)
    //     .multiplyScalar(this.cameraNoiseAmplitude)

    //   this.cameraPosition.copy(this.camera.position)
    //   this.cameraRotation.copy(this.camera.rotation)

    //   this.camera.position.add(this.cameraPositionNoise)
    //   this.camera.rotation.x += this.cameraRotationNoise.x
    //   this.camera.rotation.y += this.cameraRotationNoise.y
    //   this.camera.rotation.z += this.cameraRotationNoise.z
    // }

    this.renderer.render()
    this.frameID = requestAnimationFrame(this.tick)

    // if (this.cameraNoiseAmplitude) {
    //   this.camera.position.copy(this.cameraPosition)
    //   this.camera.rotation.copy(this.cameraRotation)
    // }
  }

  start () {
    this.resize()
    this.tick()

    addEventListener('resize', this.resize, { passive: true })
  }

  set el (el) {
    this.container = el
    this.container.appendChild(this.renderer.canvas)
  }

  resize () {
    this.renderer.resize()
  }

  destroy () {
    this.renderer.destroy()
    this.tick = ()=>{}
  }
}
